<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_text">
                        <span>個人詞典</span>
                        <h1>使用個人詞典來自訂Trinka</h1>
                        <p>使用個人詞典來避免使用新術語時的拼寫提醒。只需添加Trinka不知道的單詞，例如品牌名稱或新技術，Trinka就會一直記住它們。</p>
                        <a href="https://cloud.trinka.ai/signup?_rg=TW" id="autoEditGetStart" target="_blank">開始使用</a>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_img">
                        <img src="../../../assets/images/Personal-Dictionary.png" alt="personal dictionary">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="SectionHowItWrok">
        <div class="container">
            <div class="row">
                <div class="col-xl-6">
                    <div class="ImgSectionHowItWrok">
                        <a href="" data-toggle="modal" data-target="#wordPluginPopup" id="VewiVideoSection">
                            <img src=".././../../assets/images/MyDicitonayThumbnail.png" alt="" class="img-fluid eposter-img">
                        </a>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="contentSectionHowItWrok">
                        <h2>看它是如何工作的</h2>
                        <div class="HeadingSubLine"></div>
                        <p style="margin-bottom: 10px;">查看簡單的示範影片，立即開始構建您的個人詞典。</p>
                        <p style="margin-bottom: 10px;">這個詳細的分步教程可幫助您充分利用Trinka的強大功能。如果您有更多問題，請在
                            <a style="color: #0000ff;" (click)="scroll(target)" class="link">此處</a>瀏覽我們的常見問題解答。</p>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="keyFeatureSection">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h2>Trinka個人詞典的主要特點</h2>
                    <div class="HeadingSubLine"></div>
                    <p style="margin-bottom: 40px;">擺脫不必要的文字標記，讓您的寫作流暢自然。</p>
                </div>
            </div>
        </div>
    </div>

    <div class="writeToolboxs_section">
        <div class="writeToolbox_inner_sections" style="background-image: url('../../../assets/images/toolbox_backgrond_browser_plugin_r.png');">
            <div class="container">
                <div class="row">
                    <div class="col-lg-5">
                        <div class="toolbox_img_content">
                            <img src="../../../assets/images/correct-spelling.png" alt="correct spelling" class="img-fluid">
                        </div>
                    </div>
                    <div class="col-lg-7">
                        <div class="toolbox_text_content">
                            <h3>詞的分類</h3>
                            <p>您可以將個人詞典中的單詞分類為正確的拼寫、技術程式名稱、生物學名稱、產品名稱等。隨著您使用的增多，Trinka會變得更好。</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="writeToolbox_inner_sections">
            <div class="container">
                <div class="row">
                    <div class="col-lg-7">
                        <div class="toolbox_text_content">
                            <h3>調整大小寫敏感度</h3>
                            <p>您甚至可以設置Trinka，在匹配大小寫時決定是否忽略您的個人詞典和術語。</p>
                        </div>
                    </div>
                    <div class="col-lg-5">
                        <div class="toolbox_img_content">
                            <img src="../../../assets/images/case-sensitive.png" alt="case sensitive" class="img-fluid">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections" style="background-image: url('../../../assets/images/toolbox_backgrond_browser_plugin_r.png');">
            <div class="container">
                <div class="row">
                    <div class="col-lg-5">
                        <div class="toolbox_img_content">
                            <img src="../../../assets/images/american-english.png" alt="american english" class="img-fluid">
                        </div>
                    </div>
                    <div class="col-lg-7">
                        <div class="toolbox_text_content">
                            <h3>選擇英文類型</h3>
                            <p>Trinka允許您設置是否在英語類型匹配時忽略添加的術語，或者全部忽略。</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="writeToolbox_inner_sections">
            <div class="container">
                <div class="row">
                    <div class="col-lg-7">
                        <div class="toolbox_text_content">
                            <h3>跨平台同步</h3>
                            <p>您添加到詞典中的所有單詞會在所有平台上即時自動同步，包括雲編輯器、微軟Word外掛程式以及瀏覽器外掛程式。您的Trinka詞典能在任何地方使用。</p>
                        </div>
                    </div>
                    <div class="col-lg-5">
                        <div class="toolbox_img_content noBackgroundColor syncAcrossImages">
                            <img src="../../../assets/images/SyncAcrossPlatforms.png" alt="sync accross platforms" class="img-fluid" style="max-width: 300px;">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="writeToolbox_inner_sections" style="background-image: url('../../../assets/images/toolbox_backgrond_browser_plugin_r.png');">
            <div class="container">
                <div class="row">
                    <div class="col-lg-5">
                        <div class="toolbox_img_content noBackgroundColor">
                            <img src="../../../assets/images/MyDictionary_Brand-tone.png" alt="" class="img-fluid">
                        </div>
                    </div>
                    <div class="col-lg-7">
                        <div class="toolbox_text_content">
                            <h3>保持品牌用語的一致
                            </h3>
                            <p>添加您單位的詞典和新術語來個性化您的寫作助手，在所有通信中保持品牌用語的一致。</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="cloud_key_features" style="display: none;">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="key_features_heading">
                        <h2>Trinka個人詞典的主要特點</h2>
                        <div class="HeadingSubLine"></div>
                        <p>擺脫不必要的文字標記，讓您的寫作流暢自然。
                        </p>
                    </div>
                </div>
            </div>
            <div class="row">

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/BuildYourVeryOwnDictionary.png" alt="">
                        <h3>Build Your Very Own Dictionary</h3>
                        <p>Create your own dictionary by adding terms as you use Trinka or just add them all in one go. You
                            can edit and delete words any time.
                        </p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/CategorizationOfWords.png" alt="">
                        <h3>Categorization of Words</h3>
                        <p>You can organize the words you add to your dictionary as correct spellings, technical procedure names,
                            biological names, product names, etc. Trinka gets better as you do.
                        </p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/AdjustCaseSensitivity.png" alt="">
                        <h3>Adjust Case Sensitivity</h3>
                        <p>You can even control whether Trinka should ignore your dictionary terms when they match casing or
                            regardless.
                        </p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <img src="../../../assets/images/ChooseEnglishType.png" alt="">
                        <h3>Choose English Type</h3>
                        <p>Trinka lets you control whether added terms are ignored when the English type matches or are ignored
                            regardless.
                        </p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <span>Enterprise</span>
                        <img src="../../../assets/images/MaintainBrandTone.png" alt="">
                        <h3>Maintain Brand Tone</h3>
                        <p>Add your organization lexicon and new terms to stay on brand across all communications & personalize
                            your writing assistance. </p>
                    </div>
                </div>

                <!-- <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <img src="../../../assets/images/subjectAreaAndDocumentType.svg" alt="subject area document">
                        <h3>Advanced Controls</h3>
                        <p>With advanced controls, you can search for words and sort them too based on recent additions and
                            alphabetical order.</p>
                    </div>
                </div> -->

            </div>
        </div>
    </div>

    <div class="forpersonlized_sections">
        <p>使用自訂字典來個性化您的寫作</p>
        <div class="forpersonlizedFooter">
            <a href="https://cloud.trinka.ai/signup?_rg=TW" target="_blank">開始使用</a>
        </div>
    </div>

    <div class="pricingQuestionAnwser" #target>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="pricingHeadingQuestion">
                        <h2>常見問題</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
                <div class="col-lg-10">
                    <div class="pricingQuestionsList">
                        <div class="accordion" id="faq">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        其他人可以訪問我添加的單詞嗎？</a>
                                </div>

                                <div id="QuestionOneContent" class="collapse show" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>您的個人字典是獨有的，其他人不能訪問或使用它。</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">我在哪裡可以找到個人詞典？</a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>在您的
                                            <a href="https://cloud.trinka.ai/dashboard/profile" target="_blank">帳戶設置</a>中，在“寫作設置”部分你可以找到“我的詞典”按鈕。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        我可以與其他帳戶共用個人字典嗎？
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>您的個人字典是獨有的，不能與其他帳戶共用。</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        我可以下載個人詞典嗎？
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>目前您無法下載個人字典，我們將很快添加此功能。
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="card">
                                <div class="card-header" id="QuestionFive">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFiveContent" aria-expanded="true"
                                        aria-controls="QuestionFiveContent">
                                        使用個人詞典來自訂Trinka
                                    </a>
                                </div>

                                <div id="QuestionFiveContent" class="collapse" aria-labelledby="QuestionFive" data-parent="#faq">
                                    <div class="card-body">
                                        <p>將Trinka無法識別的單詞添加到您個人詞典中，例如品牌名稱或新技術術語，以避免拼寫警示。
                                        </p>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
            </div>
        </div>
    </div>
    <div class="use_trinka_other_app">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="use_trinka_content">
                        <div class="use_trinka_heading">
                            <div class="howItWorkHeading lineWhiteColor">
                                <h2>在其他應用程式
                                    <br />中使用Trinka</h2>
                                <div class="HeadingSubLine"></div>
                            </div>
                        </div>
                        <div class="others_app_name">
                            <ul>
                                <li>
                                    <a href="https://www.trinka.ai/tw/trinkacloud">
                                        <div class="app_name_content" routerLink="/trinkacloud">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Other_apps_TrinkaCloud.svg" alt="trinka cloud">
                                            <h3>Trinka Cloud</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/tw/wordplugin">
                                        <div class="app_name_content" routerLink="">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Others_App_MSWord.svg" alt="ms word">
                                            <h3>MS Word
                                                <br />外掛程式</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/tw/browser-plugin">
                                        <div class="app_name_content" routerLink="/browser-plugin">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/other_Apps_browser.svg" alt="browser">
                                            <h3>瀏覽器
                                                <br />外掛程式</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/tw/enterprise">
                                        <div class="app_name_content" style="padding: 0px;" routerLink="/enterprise">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Other_Apps_enterprise.svg" alt="enterprise apps">
                                            <h3 style="margin: 0 0 -2px 0;">企業</h3>
                                            <span style="font-size: 12px; color: #000; position: relative;">(API, JS & On-Premise)
                                            </span>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/5KsBh4PQUPI"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>